export const userSelectors = {
  id: (state) => state.id,
  name: (state) => state.name,
  userId: (state) => state.userId,
  permissions: (state) => state.permissions,
  update: (state) => state.update,
}
